export function formatDate(date) {
    if (!(date instanceof Date)) {
        throw Error(`formatDate expects a Date object but got ${typeof date}`);
    }
    return date.toISOString().split('T')[0];
}

export function formatUTCDateTime(date = new Date(), displayTime = true, delimiter = '-') {
    if (!(date instanceof Date)) {
        throw Error(`formatUTCDateTime expects a Date object but got ${typeof date}`);
    }
    const dateString =
        date.getUTCFullYear() +
        delimiter +
        ('00' + (date.getUTCMonth() + 1)).slice(-2) +
        delimiter +
        ('00' + date.getUTCDate()).slice(-2);

    if (!displayTime) return dateString;

    return (
        dateString +
        ' ' +
        ('00' + date.getUTCHours()).slice(-2) +
        ':' +
        ('00' + date.getUTCMinutes()).slice(-2) +
        ':' +
        ('00' + date.getUTCSeconds()).slice(-2)
    );
}
